export enum SsoPlatformVisibilityOption {
  APP_AND_ADMIN = 'app_and_admin',
  APP = 'app',
  ADMIN = 'admin'
}
